import Vue from 'vue'
import Vuelidate from '../core'
import { version } from 'vuelidate/package.json'

Vue.$app = Vue.$app || {}

Vue.$app.vuelidate = Vuelidate
Vue.$app.vuelidate.version = version
